module.exports = __webpack_public_path__ + "static/icon_jf.120fa3a7.png";